import { AcordoStatus } from "core/features/acordo/enums";
import moment from "moment";

export const getStatusAcordoText = (
  status: AcordoStatus,
  dataCancelamento?: string
) => {
  const textMap: Record<AcordoStatus, string> = {
    [AcordoStatus.Cancelado]: `Cancelado em
    ${moment(dataCancelamento).format("DD/MM/YYYY")}`,
    [AcordoStatus.EmAberto]: "Em aberto",
    [AcordoStatus.Pago]: "Pago",
    [AcordoStatus.Renegociado]: "Renegociado",
    [AcordoStatus.Encerrado]: "Encerrado",
  };

  return textMap[status];
};
